export default {
  "command-tint1": {
    name: "command-tint1"
  },
  "command-tint2": {
    name: "command-tint2"
  },
  "command-tint3": {
    name: "command-tint3"
  },
  "command-tint4": {
    name: "command-tint4"
  },
  "command-tint5": {
    name: "command-tint5"
  },
  "command-tint6": {
    name: "command-tint6"
  },
  "command-tint7": {
    name: "command-tint7"
  },
  "command-tint8": {
    name: "command-tint8"
  }
};
